var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntroPivotalIgnoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6794 2.46362L2.46484 18.6782L26.7867 43.0001L2.46484 67.322L18.6794 83.5365L43.0013 59.2147L67.3232 83.5365L83.5378 67.322L59.2159 43.0001L83.5378 18.6782L81.5221 16.6514L67.3232 2.46362L43.0013 26.7855L18.6794 2.46362ZM18.6794 10.5709L43.0013 34.8928L67.3232 10.5709L75.4305 18.6782L51.1086 43.0001L75.4305 67.322L67.3232 75.4292L43.0013 51.1074L18.6794 75.4292L10.5721 67.322L34.894 43.0001L10.5721 18.6782L18.6794 10.5709Z",
    fill: "#F15D58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroPivotalIgnoreIcon);
export default __webpack_public_path__ + "static/media/intro_pivotal_ignore_icon.d9ecf0cdad59c80e8e5d4a9842b3edf1.svg";
export { ForwardRef as ReactComponent };